<div class="dialog">
  <!-- close button -->
  <button mat-button class="dialog__close" (click)="onClose()">
    <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon
      ><span>{{ 'recordsSearch.close' | translate | uppercase }}</span>
    </button>

    <!-- title -->
    <div mat-dialog-title>
      <h3>{{ wizardTitle | translate | uppercase }}</h3>
    </div>

    @if (wizardSubTitle) {
      <p class="subtitle">
        {{ wizardSubTitle | translate }}
      </p>
    }

    <!-- boby -->
    <div mat-dialog-content>
      <div class="wizard">
        <div class="steps-set orange-tabs">
          @if (wizardDriverService.currentStep$ | async; as currentStep) {
            <mat-tab-group [selectedIndex]="currentStep.stepNumber - 1" (selectedIndexChange)="loadStepByIndex($event)">
              @for (tab of stepTabs; track tab; let last = $last) {
                <mat-tab
                  [disabled]="!stepReady && (!wizardDef.allowBackwardTabNavigation || tab.step.stepNumber > currentStep.stepNumber)"
              [ngClass]="{
                disabled: !stepReady && (!wizardDef.allowBackwardTabNavigation || tab.step.stepNumber > currentStep.stepNumber),
                last: last,
              }"
                  >
                  <ng-template mat-tab-label>
                    {{ tab.step.name | translate | uppercase }}
                    @if (!last) {
                      <mat-icon class="mat-icon-arrow" svgIcon="arrow-front"></mat-icon>
                    }
                  </ng-template>
                </mat-tab>
              }
            </mat-tab-group>
          }
        </div>
        <!-- STEP PROJECTOR -->
        <div class="projection">
          <ng-template miqWizardProjector></ng-template>
        </div>
      </div>
    </div>

    <!-- global actions -->
    <div mat-dialog-actions>
      @if (!isFirst && !hideBackButton) {
        <button class="btn-cancel-outlined-100 btn" (click)="prev()">
          {{ 'recordsSearch.back' | translate }}
        </button>
      }
      <span class="dontcreate-btn">
        @if (showStopButton) {
          <button miq-go-back-link class="float-right btn-submit btn" [hideIcon]="true">
            {{ 'recordsSearch.dontCreate' | translate }}
          </button>
        }
      </span>
      @if (isLast) {
        <button class="btn-submit" [disabled]="!stepReady" (click)="next()">
          {{ lastButtonText | translate }}
        </button>
      } @else {
        <button class="btn-submit-100" type="submit" [disabled]="!stepReady" (click)="next()">
          {{ 'recordsSearch.next' | translate }}
        </button>
      }
    </div>
  </div>
